
import { DietaryRestriction } from "@/types/dietary";

export const dietaryRestrictions: DietaryRestriction[] = [
  {
    name: "Sugar Alternatives",
    keywords: ["sugar", "brown sugar", "granulated sugar", "powdered sugar", "honey", "maple syrup"],
    alternatives: [
      {
        original: "White Sugar",
        replacement: "Monk Fruit Sweetener",
        note: "A natural zero-calorie sweetener that's perfect for baking!",
        keywords: ["sugar", "granulated sugar", "white sugar"]
      },
      {
        original: "Brown Sugar",
        replacement: "Coconut Sugar",
        note: "Has a natural caramel flavor and works great in baking!",
        keywords: ["brown sugar", "dark brown sugar", "light brown sugar"]
      },
      {
        original: "Powdered Sugar",
        replacement: "Powdered Monk Fruit or Erythritol",
        note: "Perfect for frostings and dustings!",
        keywords: ["powdered sugar", "confectioners sugar", "icing sugar"]
      },
      {
        original: "Honey",
        replacement: "Agave Nectar",
        note: "A natural liquid sweetener with a lower glycemic index!",
        keywords: ["honey"]
      },
      {
        original: "Maple Syrup",
        replacement: "Date Syrup",
        note: "A natural sweetener made from dates - full of minerals!",
        keywords: ["maple syrup", "maple"]
      }
    ]
  },
  {
    name: "Healthy Alternatives",
    keywords: ["sugar", "butter", "oil", "cream", "flour", "salt"],
    alternatives: [
      {
        original: "Sugar",
        replacement: "Maple Syrup or Honey",
        note: "Natural sweeteners add nutrients while sweetening!",
        keywords: ["sugar", "granulated sugar", "white sugar"]
      },
      {
        original: "Butter",
        replacement: "Applesauce or Mashed Banana",
        note: "For baking, these alternatives add moisture with less fat!",
        keywords: ["butter", "unsalted butter", "salted butter"]
      },
      {
        original: "White Flour",
        replacement: "Whole Wheat Flour or Almond Flour",
        note: "These alternatives add more fiber and nutrients!",
        keywords: ["flour", "all-purpose flour", "white flour"]
      },
      {
        original: "Heavy Cream",
        replacement: "Greek Yogurt or Coconut Milk",
        note: "These options provide protein or healthy fats!",
        keywords: ["cream", "heavy cream", "whipping cream"]
      },
      {
        original: "Vegetable Oil",
        replacement: "Applesauce or Greek Yogurt",
        note: "For baking, these alternatives reduce fat while keeping moisture!",
        keywords: ["oil", "vegetable oil", "canola oil"]
      }
    ]
  },
  {
    name: "Gluten-Free",
    keywords: ["flour", "bread", "pasta", "wheat", "breadcrumbs"],
    alternatives: [
      {
        original: "All-Purpose Flour",
        replacement: "Gluten-Free Flour Blend",
        note: "Look for a 1:1 baking flour that already contains xanthan gum!",
        keywords: ["flour", "all-purpose flour", "all purpose flour"]
      },
      {
        original: "Bread Crumbs",
        replacement: "Gluten-Free Bread Crumbs or Crushed Rice Cereal",
        note: "These work just as well for coating or binding!",
        keywords: ["bread crumbs", "breadcrumbs", "bread crumb"]
      }
    ]
  },
  {
    name: "Dairy-Free",
    keywords: ["milk", "butter", "cheese", "cream", "yogurt"],
    alternatives: [
      {
        original: "Milk",
        replacement: "Almond Milk or Oat Milk",
        note: "These plant-based milks work great in baking!",
        keywords: ["milk", "whole milk", "2% milk", "skim milk"]
      },
      {
        original: "Butter",
        replacement: "Coconut Oil or Dairy-Free Butter",
        note: "They'll make your treats just as yummy!",
        keywords: ["butter", "unsalted butter", "salted butter"]
      }
    ]
  },
  {
    name: "Egg-Free",
    keywords: ["egg", "eggs"],
    alternatives: [
      {
        original: "1 Egg",
        replacement: "1 Mashed Banana or 1/4 cup Applesauce",
        note: "These help keep your baked goods moist and fluffy!",
        keywords: ["egg", "eggs", "large egg", "egg yolk", "egg white"]
      },
      {
        original: "Egg Wash",
        replacement: "Plant Milk + Maple Syrup",
        note: "Brush this on top for a golden-brown color!",
        keywords: ["egg wash", "egg-wash"]
      }
    ]
  },
  {
    name: "Nut-Free",
    keywords: ["almond", "peanut", "walnut", "pecan", "cashew", "nut"],
    alternatives: [
      {
        original: "Almond Flour",
        replacement: "Sunflower Seed Flour or Oat Flour",
        note: "These are safe alternatives that taste great!",
        keywords: ["almond flour", "almond meal"]
      },
      {
        original: "Peanut Butter",
        replacement: "Sunflower Seed Butter or Pumpkin Seed Butter",
        note: "Just as creamy and delicious!",
        keywords: ["peanut butter", "almond butter", "nut butter"]
      }
    ]
  },
  {
    name: "Seed Oil-Free",
    keywords: ["vegetable oil", "canola oil", "sunflower oil", "safflower oil", "soybean oil", "corn oil", "rapeseed oil"],
    alternatives: [
      {
        original: "Vegetable Oil",
        replacement: "Extra Virgin Olive Oil or Coconut Oil",
        note: "These natural oils are healthier choices!",
        keywords: ["vegetable oil", "canola oil", "sunflower oil", "safflower oil", "soybean oil", "corn oil", "rapeseed oil"]
      },
      {
        original: "Cooking Spray",
        replacement: "Butter or Coconut Oil",
        note: "Use these natural fats for greasing pans!",
        keywords: ["cooking spray", "non-stick spray", "baking spray"]
      }
    ]
  }
];
